import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../homePage/components/footer/Footer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MapPinCheck } from "lucide-react";
import { PhoneCall } from "lucide-react";
import { PrinterCheck } from "lucide-react";
import { MailCheck } from "lucide-react";
import Heading from "../utils/Heading";
import { addLead } from "../../../redux/api/admin/leadApi";
import toast from "react-hot-toast";
import { getRoleList } from "../../../redux/reduxApi/admin/Role";
import { getEmployeesList } from "../../../redux/reduxApi/admin/EmployeesReduxApi";
import { useDispatch } from "react-redux";

export default function ContactUs() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
    leadOwner: null
  });
  const [selectedDate, setSelectedDate] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    dispatch(getRoleList({
      page: 1, size: 30, search: [{
        "field": "roleName",
        "operation": "is",
        "value": "Sales Manager"
      }]
    })).then((resp) => {
      const roleId = resp.payload?.data?.roles[0].id;
      if (!roleId) return;
      dispatch(getEmployeesList({
        page: 1, limit: 30, search: [{
          "field": "role",
          "operation": "is",
          "value": roleId
        }]
      })).then((resp) => {
        const SalesManagerId = resp.payload?.data?.employees[0].ROWID;
        if (!SalesManagerId) return;
        setFormData((prev) => ({
          ...prev,
          leadOwner: SalesManagerId
        }))
      }).catch((error) => {
        console.error("Error fetching employee id:", error);
      })

    }).catch((error) => {
      console.error("Error fetching roles id:", error);
    })
  }, [])

  const validateForm = () => {
  if (!formData.firstName.trim()) {
    toast.error("First name is required");
    return false;
  }

  if (!formData.mobile.trim()) {
    toast.error("Phone number is required");
    return false;
  }

  // phone validation (India basic)
  if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
    toast.error("Enter a valid 10-digit phone number");
    return false;
  }

  if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email)) {
    toast.error("Enter a valid email address");
    return false;
  }

  if (!formData.subject) {
    toast.error("Please select a subject");
    return false;
  }

  if (!formData.message.trim()) {
    toast.error("Message cannot be empty");
    return false;
  }

  if (!formData.leadOwner) {
    toast.error("Please wait, loading...");
    return false;
  }

  return true;
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        description: `Subject: ${formData.subject}\nMessage: ${formData.message}`,

        leadOwner: formData.leadOwner,


        leadSource: "Website",
        leadStatus: "Open",
        leadType: "domestic"
      };

      const res = await addLead(payload);

      // console.log("Success:", res.data);
      toast.success("Form submitted successfully");

      setFormData((prev) => ({
        ...prev,
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        subject: "",
        message: ""
      }));

    } catch (error) {
      // console.error("Error:", error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[75px]">
      <div>
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d333742.956560374!2d-122.84727100000002!3d49.1936!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485d78098737099%3A0x726f5b8ccad3abff!2s10509%20135a%20St%2C%20Surrey%2C%20BC%20V3T%204C9%2C%20Canada!5e0!3m2!1sen!2sus!4v1738318150325!5m2!1sen!2sus"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe> */}
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17390.271799532216!2d76.86106063050926!3d30.584356417601946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fbfd2d437b867%3A0x225056f20b33ec6b!2sIndustrial%20Land%20Zone%2C%20Saidpura%2C%20Dera%20Bassi%2C%20Punjab%20140507!5e0!3m2!1sen!2sin!4v1756269947653!5m2!1sen!2sin"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe> */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3434.9859158334343!2d76.8991795!3d30.57794299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fbe1440de703d%3A0xacf5982e7ebd168d!2sWintree%20blinds!5e0!3m2!1sen!2sin!4v1774501904464!5m2!1sen!2sin"
          width="100%"
          height="450"
          loading="lazy"
          allowfullscreen
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
      <div class="container mx-auto py-[50px]">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <Heading text={"GET IN TOUCH"} className="text-left" />
            <hr className="heading-seperator mx-auto border-t-4 border-[#66944b] opacity-90 w-16 sm:w-20 md:w-24 h-0.5 !mb-3 lg:!mb-5 lg:mt-2 md:mt-2 md:!mb-4 transition-all duration-500 hover:w-32" />
           

            <p className="text-gray-600 mb-6 leading-relaxed">   <span className="text-lg text-gray-700"> Looking for customized window covering solutions? If you need information about our products, pricing, or customization options, our team is ready to assist.</span>        </p>


            {/* <p class="text-black-600 mb-6">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua
            </p> */}
            <p className="text-gray-600 mb-6 leading-relaxed">
              <span className="text-lg text-gray-700">From individual requirements to large-scale projects, we provide clear guidance and direct support from our manufacturing facility.</span>

            </p>

            <p className="text-gray-600 mb-6 leading-relaxed">
              <span className="text-lg text-gray-700"> Contact us to discuss your needs. We look forward to working with you.

              </span>

            </p>


            <div class="mb-4">
              <h1 class="font-bold mb-2 text-xl">Let's Talk</h1>
              <p class="flex items-center mb-3">
                <MapPinCheck className="mr-2 -mt-10 text-[#66944b]" />
                {/* Dera Bassi Industrial Area 140507, PB ,
                India{" "} */}
                Plot No. 4, Bhagwanpur Industrial Park<br />
                Derabassi–Barwala Road<br />
                Derabassi, Punjab – 140507, India             </p>
              <p class="flex items-center mb-3">
                <PhoneCall className="mr-2 text-[#66944b]" /> +91 9872209400
              </p>
              {/* <p class="flex items-center mb-3">
                <PrinterCheck className="mr-2" /> (604) 581-9324
              </p> */}
              <p class="flex items-center mb-3">
                <MailCheck className="mr-2 text-[#66944b]" /> nitin@wintree.in
              </p>
            </div>
          </div>
          <div class="border-2 border-[#66944b] p-4 rounded-lg">
            {/* <Heading text={"Send Us a Message"} className="text-center  text-[12px] whitespace-nowrap" /> */}
            {/* <h1 className="ml-[50px] sm:ml-0 text-left sm:text-center text-2xl md:text-3xl lg:text-4xl whitespace-nowrap">
              Send us a Message
            </h1>     */}
            <Heading text={"Send us a Message"} />
              <hr className="heading-seperator mx-auto border-t-4 border-[#66944b] opacity-90 w-16 sm:w-20 md:w-24 h-0.5 !mb-3 lg:!mb-5 lg:mt-2 md:mt-2 md:!mb-4 transition-all duration-500 hover:w-32" />
           
            <p class="text-black-600 mb-6 text-center !mt-1 md:!mt-3">
              Tell us a little about your requirement. Our team will review your query and respond promptly with the right guidance.
            </p>
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  First Name<span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  className="mt-1 block w-full border border-black p-2"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />

              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Last Name<span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  className="mt-1 block w-full border border-black p-2"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  className="mt-1 block w-full border border-black p-2"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="block whitespace-nowrap text-sm font-medium text-gray-700">
                  Phone Number<span className="text-red-600">*</span>
                </label>
                <input
                  type="tel"
                  className="mt-1 block w-full border border-black p-2"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </div>


              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Subject<span className="text-red-600">*</span>
                </label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-black p-2"
                >
                  <option value="">Choose</option>
                  <option value="Enquiry">Enquiry</option>
                  <option value="Feedback">Feedback</option>
                  <option value="Product Related Enquiry">Product Related Enquiry</option>
                  <option value="Complaint">Complaint</option>
                </select>
              </div>


              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Message<span className="text-red-600">*</span>
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  className="mt-1 block w-full border border-black p-2 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>
              <div className="md:col-span-2">
                <button
                  type="submit"
                  className="w-full bg-[#66944b] text-white font-bold py-2 px-4"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
    //   <div className="min-h-screen bg-gradient-to-b from-[#011638] via-white to-[#DFF7EB] py-12 px-4 sm:px-6 lg:px-8">
    //   <div className="max-w-4xl mx-auto">
    //     <motion.h1
    //       initial={{ opacity: 0, y: -50 }}
    //       animate={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.6 }}
    //       className="text-5xl font-bold text-center text-transparent bg-clip-text text-white mb-8"
    //     >
    //       Contact Us
    //     </motion.h1>

    //     <motion.p
    //       initial={{ opacity: 0 }}
    //       animate={{ opacity: 1 }}
    //       transition={{ delay: 0.3, duration: 0.8 }}
    //       className="text-center text-lg text-slate-300 max-w-2xl mx-auto mb-12"
    //     >
    //       Have questions or want to get in touch? We’d love to hear from you. Whether it's about our products,
    //       your order, or general inquiries — reach out using the form below.
    //     </motion.p>

    //     <motion.form
    //       initial={{ opacity: 0, scale: 0.95 }}
    //       animate={{ opacity: 1, scale: 1 }}
    //       transition={{ delay: 0.5, duration: 0.6 }}
    //       className="bg-white rounded-2xl shadow-xl p-8 space-y-6"
    //     >
    //       <div>
    //         <label htmlFor="name" className="block text-sm font-medium text-gray-700">
    //           Name
    //         </label>
    //         <input
    //           type="text"
    //           id="name"
    //           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-4 py-2 focus:ring-amber-500 focus:border-amber-500"
    //           placeholder="Your name"
    //         />
    //       </div>

    //       <div>
    //         <label htmlFor="email" className="block text-sm font-medium text-gray-700">
    //           Email
    //         </label>
    //         <input
    //           type="email"
    //           id="email"
    //           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-4 py-2 focus:ring-amber-500 focus:border-amber-500"
    //           placeholder="you@example.com"
    //         />
    //       </div>

    //       <div>
    //         <label htmlFor="message" className="block text-sm font-medium text-gray-700">
    //           Message
    //         </label>
    //         <textarea
    //           id="message"
    //           rows="4"
    //           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-4 py-2 focus:ring-amber-500 focus:border-amber-500"
    //           placeholder="How can we help you?"
    //         ></textarea>
    //       </div>

    //       <div className="text-center">
    //         <button
    //           type="submit"
    //           className="inline-block bg-gradient-to-r from-[#011638] to-[#DFF7EB] text-white px-6 py-3 rounded-full text-lg shadow-md hover:from-[#DFF7EB] hover:to-[#011638] transition"
    //         >
    //           Send Message
    //         </button>
    //       </div>
    //     </motion.form>

    //     <motion.div
    //       className="mt-12 text-center text-sm text-gray-500"
    //       initial={{ opacity: 0 }}
    //       animate={{ opacity: 1 }}
    //       transition={{ delay: 0.7, duration: 0.6 }}
    //     >
    //       <p>Email us directly at <a href="mailto:support@example.com" className="text-amber-600 underline">support@example.com</a></p>
    //     </motion.div>
    //   </div>
    // </div>
  );
}
